import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { canAuthor } from '../../../helpers/userAuth';
import { selectCurrentUser } from '../../../selectors/authSelectors';

const AuthorViewLearning3kGradedQuiz = ({ gradedQuizId }) => {
  const currentUser = useSelector(selectCurrentUser);
  const isAuthor = canAuthor(currentUser);

  if (!isAuthor) {
    return null;
  }

  if (!gradedQuizId) {
    return null;
  }

  const handleClick = () => {
    const railsUrl = `/learning/graded_quiz_preview/${gradedQuizId}`;
    window.open(railsUrl, '_blank');
  };

  return (
    <button className="header-bar__edit-3k" onClick={handleClick}>
      L3k View
    </button>
  );
};
AuthorViewLearning3kGradedQuiz.propTypes = {
  gradedQuizId: PropTypes.string.isRequired,
};

export default AuthorViewLearning3kGradedQuiz;
